var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Not Found")]),_c('p',[_vm._v(" Oups, la page demandée n'a pas été trouvée. Essayez de retourner à la "),_c('router-link',{attrs:{"to":"/"}},[_vm._v(" page d'accueil ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }